import {AbstractNavPanel} from "@/scenes.ui/abstract-nav-panel";
import Scene = Phaser.Scene;
import {Creature} from "@/store/level/types";
import CreaturePanel from "@/scenes.ui/creature-panel";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class PickArtifactCreaturesNavPanel extends AbstractNavPanel {

    private onClickCallback: (creatureId: number) => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number,
                creatures: Creature[], onClickCallback: (creatureId: number) => unknown) {
        super(scene, canvas, x, y, creatures, 3);

        this.x = x * CU.S;
        this.y = y * CU.S;

        this.onClickCallback = onClickCallback;

    }

    protected makePanel(x: number, element: any): any {

        let creaturePanel = new CreaturePanel(this.scene!, x, 10, <Creature>element, () => undefined, true);
        creaturePanel.setHealthVisible();
        creaturePanel.setDepth(1000);
        SpriteUtils.scale(creaturePanel, 1 / CU.S);

        creaturePanel.setCallback(() => {
            if(this.onClickCallback != null) {
                this.playSelectSound();
                this.onClickCallback(creaturePanel.getCreature().id);
            }
        });

        return creaturePanel;

    }

    protected getButtonX(): number {
        return 198;
    }

    protected getButtonY(): number {
        return 10;
    }

    protected calculateCellWidth(creaturesAmount: number): number {
        return creaturesAmount === 2 ? 180 : 130;
    }


}
